
import { styled, css } from '@core-ui/react-stitch';
import { Theme } from '@core-ui/react-stitch/types';

interface DashBoardTitleStyleProps extends  DashBoardTitleProps{
  theme: Theme,
  withChevron?: boolean
}
interface DashBoardTitleProps {
  withChevron?: boolean
}

const getChevronBackground = (color: string) => {
  const chevron = `svg xmlns='http://www.w3.org/2000/svg' width='9' height='6' viewBox='0 0 9 6'%3E%3Cpath d='M.003 1.533L1.118.529l3.385 3.047L7.89.529l1.114 1.004-4.5 4.05z' style='fill:${color.replace('#', '')};fill-rule:evenodd'`;
  return `url("data:image/svg+xml;charset=utf8,%3C${chevron} /%3E%3C/svg%3E") no-repeat`;
};

const getDashboardTitleStyles = ({ theme, withChevron = true }: DashBoardTitleStyleProps) => {
  const background = getChevronBackground(theme.color.b1);
  return css({
    color: theme.color.b1,
    fontWeight: 600,
    textTransform: 'uppercase',
    fontSize: '0.88rem',
    background: withChevron ? background : '',
    backgroundPositionX: 'right',
    backgroundPositionY: '50%',
    paddingRight: withChevron ? '0.8rem' : 0,
  });
};
const DashboardTitle = styled.label<DashBoardTitleProps>`
    ${getDashboardTitleStyles};
`;

export default DashboardTitle;
